import api from '../../../../App/socket';

export const removeUserEmail = (email_id, _id) => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'NestedDelete',
        options: {
            fullPath: `person.emails.${email_id}`,
            where: { _id },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_emails_requests/remove_user_email_request.js